let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Ik2u")).then(() => parcelRequire('5ZYzb'));